import {
  STATUS_SUBMITTED,
  STATUS_UPLOADED,
  STATUS_REVIWED,
  STATUS_STARTED,
  STATUS_ACCEPT,
  STATUS_APPLICATION_SUBMITTED,
  STATUS_DECLINED,
  STATUS_ACCEPTED,
} from 'src/services/constants';
import {
  equals,
  includes,
  cond,
  T
} from 'ramda';
import { getNamespaceId } from 'src/services/objects/namespaces';
import { RSNT_NAMESPACE_ID, STAR_BANK_NAMESPACE_ID } from 'src/constants';


export const LOAN_STATUS_OFFER_ACCEPTED = 'Offer Accepted';
export const LOAN_STATUS_OFFER_REJECT = 'Offer Rejected';
export const LOAN_STATUS_QUICK_DECLINE = 'Quick Decline';
export const LOAN_STATUS_DECLINE = 'Decline';
export const CONTRACT_STATUS_DECLINE = 'Contract Decline';
export const LOAN_STATUS_UNFUNDED = 'UnFunded';
export const LOAN_STAGE_APPLICATION = 'Application';
export const LOAN_STAGE_DOCUMENT_COLLECTION = 'Document Collection';
export const LOAN_STAGE_FUNDING_DECLINED = 'Declined';

export const DOCUMENT_CREATION_STATUS_LIST = [STATUS_UPLOADED, STATUS_REVIWED];
export const LENDSMART_APPLICATION_STATUS_LIST = [
  STATUS_STARTED,
  STATUS_ACCEPT,
];
const FUNDED_STATUS_LIST = [STATUS_ACCEPTED];
const DECLINED_STATUS_LIST = [STATUS_DECLINED];
const QUICK_DECLINED_STATUS_LIST = [LOAN_STATUS_QUICK_DECLINE];
const SUBMITTED_STATUS_LIST = [
  STATUS_SUBMITTED,
  STATUS_APPLICATION_SUBMITTED,
];

export const namingModificationOfLoanStatusForLoanType = (
  loanStatus: string
) => {
  switch (true) {
    case includes(loanStatus, LENDSMART_APPLICATION_STATUS_LIST):
      return LOAN_STAGE_APPLICATION;
    case includes(loanStatus, DOCUMENT_CREATION_STATUS_LIST):
      return LOAN_STAGE_DOCUMENT_COLLECTION;
    case includes(loanStatus, SUBMITTED_STATUS_LIST):
      return STATUS_APPLICATION_SUBMITTED;
    case includes(loanStatus, FUNDED_STATUS_LIST):
      return STATUS_ACCEPTED;
    case includes(loanStatus, DECLINED_STATUS_LIST):
      return LOAN_STAGE_FUNDING_DECLINED;
    case includes(loanStatus, QUICK_DECLINED_STATUS_LIST):
      return LOAN_STATUS_QUICK_DECLINE;
    default:
      return loanStatus;
  }
};

export const DeclineDropDownData = [
  {
    label: 'Business - Bank Verification Failed',
    value: 'Business - Bank Verification Failed',
  },
  { label: 'Business - Bankruptcy', value: 'Business - Bankruptcy' },
  {
    label: 'Business - Lack of Credit History',
    value: 'Business - Lack of Credit History',
  },
  {
    label: 'Business - Liens/Judgements/Major Derogs',
    value: 'Business - Liens/Judgements/Major Derogs',
  },
  {
    label: 'Cash Flow - Below Minimum Annual Revenue',
    value: 'Cash Flow - Below Minimum Annual Revenue',
  },
  {
    label: 'Cash Flow - Inconsistent or Declining Revenues',
    value: 'Cash Flow - Inconsistent or Declining Revenues',
  },
  { label: 'Cash Flow - Over-leveraged', value: 'Cash Flow - Over-leveraged' },
  {
    label: "Cash Flow - Too Many NSF's/Neg Days",
    value: `Cash Flow - Too Many NSF's/Neg Days`,
  },
  {
    label: ' Cash Flow - Unable to Improve Cash Flow',
    value: 'Cash Flow - Unable to Improve Cash Flow',
  },
  {
    label: 'Cash Flow - Unable to Verify Revenue',
    value: 'Cash Flow - Unable to Verify Revenue',
  },
  {
    label: 'Credit - Risk Score Decline',
    value: 'Credit - Risk Score Decline',
  },
  {
    label: 'Ineligible - Application Previously Received',
    value: 'Ineligible - Application Previously Received',
  },
  { label: 'Ineligible - DataMerch Hit', value: 'Ineligible - DataMerch Hit' },
  {
    label: 'Ineligible - High Risk MCA Activity',
    value: 'Ineligible - High Risk MCA Activity',
  },
  { label: 'Ineligible - Legal Entity', value: 'Ineligible - Legal Entity' },
  {
    label: 'Ineligible - MCA Balance Too High',
    value: 'Ineligible - MCA Balance Too High',
  },
  {
    label: 'Ineligible - Restricted Industry',
    value: 'Ineligible - Restricted Industry',
  },
  {
    label: 'Ineligible - Restricted State',
    value: 'Ineligible - Restricted State',
  },
  {
    label: 'Ineligible - State Specific Lending Restriction',
    value: 'Ineligible - State Specific Lending Restriction',
  },
  {
    label: 'Ineligible - Time In Business',
    value: 'Ineligible - Time In Business',
  },
  { label: 'Ineligible - # of trucks', value: 'Ineligible - # of trucks' },
  { label: 'Personal - Bankruptcy', value: 'Personal - Bankruptcy' },
  {
    label: 'Personal - Below Required Personal Credit Score',
    value: 'Personal - Below Required Personal Credit Score',
  },
  {
    label: 'Personal - Criminal History',
    value: 'Personal - Criminal History',
  },
  {
    label: 'Personal - Liens/Judgements/Major Derogs',
    value: 'Personal - Liens/Judgements/Major Derogs',
  },
  { label: 'Decline - Custom', value: 'Decline - Custom' },
  { label: 'Decline - Date Birth', value: 'Decline - Date Birth' },
];

export const DeclineDropDownDataRSNT = [
  {
    label: 'Unable to verify identity',
    value: 'Unable to verify identity',
  },
  {
    label: 'Credit application incomplete',
    value: 'Credit application incomplete',
  },
  {
    label: 'Insufficient number of credit references provided',
    value: 'Insufficient number of credit references provided'
  },
  {
    label: 'Unacceptable type of credit references provided',
    value: 'Unacceptable type of credit references provided',
  },
  {
    label: 'Unable to verify credit references',
    value: 'Unable to verify credit references',
  },
  {
    label: 'Temporary or irregular employment',
    value: 'Temporary or irregular employment',
  },
  {
    label: 'Unable to verify employment',
    value: 'Unable to verify employment',
  },
  {
    label: 'Length of employment',
    value: 'Length of employment'
  },
  {
    label: "Income insufficient for amount of credit requested",
    value: "Income insufficient for amount of credit requested",
  },
  {
    label: 'Excessive obligations in relation to income',
    value: 'Excessive obligations in relation to income',
  },
  {
    label: 'Unable to verify income',
    value: 'Unable to verify income',
  },
  {
    label: 'Length of residence',
    value: 'Length of residence',
  },
  {
    label: 'Temporary residence',
    value: 'Temporary residence',
  },
  {
    label: 'Unable to verify residence',
    value: 'Unable to verify residence'
  },
  {
    label: 'No credit file',
    value: 'No credit file',
  },
  {
    label: 'Limited credit experience',
    value: 'Limited credit experience'
  },
  {
    label: 'Poor credit performance with us',
    value: 'Poor credit performance with us',
  },
  {
    label: 'Delinquent past or present credit obligations with others',
    value: 'Delinquent past or present credit obligations with others',
  },
  {
    label: 'Collection action or judgment',
    value: 'Collection action or judgment',
  },
  {
    label: 'Garnishment or attachment',
    value: 'Garnishment or attachment',
  },
  {
    label: 'Foreclosure or repossession',
    value: 'Foreclosure or repossession',
  },
  {
    label: 'Bankruptcy',
    value: 'Bankruptcy'
  },
  {
    label: 'Number of recent inquiries on credit bureau report',
    value: 'Number of recent inquiries on credit bureau report'
  },
  {
    label: 'Value or type of collateral not sufficient',
    value: 'Value or type of collateral not sufficient',
  },
  {
    label: 'Excessive unsecured debt in relation to liquidity',
    value: 'Excessive unsecured debt in relation to liquidity',
  },
  {
    label: 'Excessive unsecured debt in relation to adjusted net worth',
    value: 'Excessive unsecured debt in relation to adjusted net worth',
  },
  {
    label: 'Proportion of balance to credit limits is too high',
    value: 'Proportion of balance to credit limits is too high',
  }
];

export const DeclineDropDownDataSTAR = [
  {
    label: 'Insufficient number of credit references',
    value: 'Insufficient number of credit references',
  },
  {
    label: 'Unable to verify credit references',
    value: 'Unable to verify credit references',
  },
  {
    label: 'No credit report file',
    value: 'No credit report file',
  },
  {
    label: 'Bankruptcy',
    value: 'Bankruptcy',
  },
  {
    label: 'Collection action or judgment',
    value: 'Collection action or judgment',
  },
  {
    label: 'Garnishment or attachment',
    value: 'Garnishment or attachment',
  },
  {
    label: 'Foreclosure or repossession',
    value: 'Foreclosure or repossession',
  },
  {
    label: 'Number of recent inquiries on credit bureau report',
    value: 'Number of recent inquiries on credit bureau report',
  },
  {
    label: 'Limited credit experience',
    value: 'Limited credit experience',
  },
  {
    label: 'Poor credit performance with us',
    value: 'Poor credit performance with us',
  },
  {
    label: 'Delinquent past or present credit obligations with others',
    value: 'Delinquent past or present credit obligations with others',
  },
  {
    label: 'Unacceptable type of credit references provided',
    value: 'Unacceptable type of credit references provided',
  },
  {
    label: 'Excessive current obligations in relation to income',
    value: 'Excessive current obligations in relation to income',
  },
  {
    label: 'Unable to verify income',
    value: 'Unable to verify income',
  },
  {
    label: 'Income insufficient for amount of credit requested',
    value: 'Income insufficient for amount of credit requested',
  },
  {
    label: 'Incomplete application',
    value: 'Incomplete application',
  },
  {
    label: 'Unable to verify employment',
    value: 'Unable to verify employment',
  },
  {
    label: 'Insufficient length of employment',
    value: 'Insufficient length of employment',
  },
  {
    label: 'Temporary or irregular employment',
    value: 'Temporary or irregular employment',
  },
  {
    label: 'Unable to verify residence',
    value: 'Unable to verify residence',
  },
  {
    label: 'Too short a period of residence',
    value: 'Too short a period of residence',
  },
  {
    label: 'Temporary residence',
    value: 'Temporary residence',
  },
  {
    label: 'Value or type of collateral insufficient',
    value: 'Value or type of collateral insufficient',
  },
  {
    label: 'Credit not granted to any applicant on terms requested',
    value: 'Credit not granted to any applicant on terms requested',
  },
  {
    label: 'Excessive unsecured debt in relation to liquidity',
    value: 'Excessive unsecured debt in relation to liquidity',
  },
  {
    label: 'Excessive unsecured debt in relation to adjusted net worth',
    value: 'Excessive unsecured debt in relation to adjusted net worth',
  }
]

export const getDeclineDropDownData = () => {
  return cond([
    [
      equals(`${RSNT_NAMESPACE_ID}`),
      () => {
        return DeclineDropDownDataRSNT
      },
    ],
    [
      equals(`${STAR_BANK_NAMESPACE_ID}`),
      () => {
        return DeclineDropDownDataSTAR
      },
    ],
    [
      T,
      () => {
        return DeclineDropDownData;
      },
    ],
  ])(getNamespaceId());
};